const translations = {
  en_GB: {
    CANCEL: 'Cancel',
    DELETE: 'Delete',
    DONE: 'Done',
    SAVE: 'Save',
    APPLY: 'Apply',
    CHANGE: 'Change',
    ADDRESS: 'Address',
    PRODUCT: 'Product',
    BILLING: 'Billing',
    SHIPPING: 'Shipping',
    DISSCOUNT_OR_VOUCHER_CODE: 'Discount or voucher code',
    BILLING_AND_SHIPPING: 'billing and shipping',
    PAY_BY_CREDIT_OR_DEBIT: 'Pay by credit/debit card',
    NAME_ON_CARD: 'Name on card',
    CARD_NUMBER: 'Card number',
    EXPIRY_DATE: 'Expiry date',
    PRICE: 'Price',
    TOTAL: 'Total',
    SUBTOTIAL_EXCLUDING_DELIVERY_TAX: 'Subtotal excl delivery & tax',
    DISCOUNT: 'Discount',
    TAX: 'Sales tax (included)',
    QUANTITY: 'Quantity',
    CHECKOUT: 'Checkout',
    VIEW_CART: 'View cart',
    CONTINUE_SHOPPING: 'Continue shopping',
    ADDRESS_DELETE_MESSAGE: 'Are you sure you want to delete this address?',
    ADD_NEW_ADDRESS: 'Add new address',
    PLEASE_SELECT_AN_ADDRESS: 'Please select an address',
    ADD_TO_CART_STRING: 'Add to cart',
    ADD_TO_CART_PREORDER_STRING: 'Pre-order now',
    ADDED_TO_BASKET: 'added to basket',
    EMPTY_CART_STRING: 'Your cart is empty.',
    ITEMS: 'Items',
    TOTAL_ITEMS: 'Total items',
    TITLE: 'Title',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    COMPANY: 'Company Name',
    ADDRESS_LINE_1: 'Address Line 1',
    ADDRESS_LINE_2: 'Address Line 2',
    CITY_TOWN: 'City/Town',
    POSTCODE: 'Post code',
    COUNTRY: 'Country',
    COUNTY: 'County',
    TELEPHONE: 'Telephone',
    MARK_AS_DEFAULT_BILLING_ADDRESS: 'Mark as default billing address',
    MARK_AS_DEFAULT_SHIPPING_ADDRESS: 'Mark as default shipping address',
    USE_SAME_ADDRESS_FOR_SHIPPING_AND_BILLING: 'Use same address for shipping and billing',
    DEFAULT_BILLING_ADDRESS: 'Default billing address',
    DEFAULT_SHIPPING_ADDRESS: 'Default shipping address',
    DEFAULT_BILLING_SHIPPING_ADDRESS: 'Default billing/shipping address',
    REQUIRED_FIELD: 'Required field',
    PLEASE_CHOOSE: 'Please choose'
  },
  en_US: {
    CANCEL: 'Cancel',
    DELETE: 'Delete',
    DONE: 'Done',
    SAVE: 'Save',
    APPLY: 'Apply',
    CHANGE: 'Change',
    ADDRESS: 'address',
    PRODUCT: 'Product',
    BILLING: 'Billing',
    SHIPPING: 'Shipping',
    DISSCOUNT_OR_VOUCHER_CODE: 'Discount or voucher code',
    BILLING_AND_SHIPPING: 'billing and shipping',
    PAY_BY_CREDIT_OR_DEBIT: 'Pay by credit/debit card',
    NAME_ON_CARD: 'Name on card',
    CARD_NUMBER: 'Card number',
    EXPIRY_DATE: 'Expiry date',
    PRICE: 'Price',
    TOTAL: 'Total',
    SUBTOTIAL_EXCLUDING_DELIVERY_TAX: 'Subtotal excl delivery & tax',
    DISCOUNT: 'Discount',
    TAX: 'Sales tax (included)',
    QUANTITY: 'Quantity',
    CHECKOUT: 'Checkout',
    VIEW_CART: 'View cart',
    CONTINUE_SHOPPING: 'Continue shopping',
    ADDRESS_DELETE_MESSAGE: 'Are you sure you want to delete this address?',
    ADD_TO_CART_STRING: 'Add to cart',
    ADD_TO_CART_PREORDER_STRING: 'Pre-order now',
    ADDED_TO_BASKET: 'added to basket',
    EMPTY_CART_STRING: 'Your cart is empty.',
    ITEMS: 'Items',
    TOTAL_ITEMS: 'Total items',
    ADD_NEW_ADDRESS: 'Add new address',
    PLEASE_SELECT_AN_ADDRESS: 'Please select an address',
    TITLE: 'Title',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    COMPANY: 'Company Name',
    ADDRESS_LINE_1: 'Address Line 1',
    ADDRESS_LINE_2: 'Address Line 2',
    CITY_TOWN: 'City/Town',
    POSTCODE: 'Zip',
    COUNTRY: 'Country',
    COUNTY: 'State',
    TELEPHONE: 'Telephone',
    MARK_AS_DEFAULT_BILLING_ADDRESS: 'Mark as default billing address',
    MARK_AS_DEFAULT_SHIPPING_ADDRESS: 'Mark as default shipping address',
    USE_SAME_ADDRESS_FOR_SHIPPING_AND_BILLING: 'Use same address for shipping and billing',
    DEFAULT_BILLING_ADDRESS: 'Default billing address',
    DEFAULT_SHIPPING_ADDRESS: 'Default shipping address',
    DEFAULT_BILLING_SHIPPING_ADDRESS: 'Default billing/shipping address',
    REQUIRED_FIELD: 'Required field',
    PLEASE_CHOOSE: 'Please choose'
  },
  fr_FR: {
    CANCEL: 'Annuler',
    DELETE: 'Effacer',
    DONE: 'Effectué',
    SAVE: 'Sauvegarder',
    APPLY: 'Appliquer',
    CHANGE: 'Changer',
    ADDRESS: 'addresse',
    PRODUCT: 'Produit',
    BILLING: 'Facturation',
    SHIPPING: 'Expédition',
    DISSCOUNT_OR_VOUCHER_CODE: 'Code de réduction ou de bon',
    BILLING_AND_SHIPPING: 'facturation and expédition',
    PAY_BY_CREDIT_OR_DEBIT: 'Payer par carte de crédit/débit',
    NAME_ON_CARD: 'Nom sur la carte',
    CARD_NUMBER: 'Numéro de carte',
    EXPIRY_DATE: "Date d'expiration",
    PRICE: 'Prix',
    TOTAL: 'Total',
    SUBTOTIAL_EXCLUDING_DELIVERY_TAX: 'Sous-total H.T. sans la livraison',
    DISCOUNT: 'Remise',
    TAX: 'Taxe',
    QUANTITY: 'Quantité',
    CHECKOUT: 'Valider',
    VIEW_CART: 'Voir votre panier',
    CONTINUE_SHOPPING: 'Continuez vos achats',
    ADDRESS_DELETE_MESSAGE: 'Etes-vous sûr de vouloir effacer cette adresse ?',
    ADD_TO_CART_STRING: 'Ajouter à votre panier',
    ADD_TO_CART_PREORDER_STRING: 'Précommandez maintenant',
    ADDED_TO_BASKET: 'ajouter à votre panier',
    EMPTY_CART_STRING: 'Votre panier est vide.',
    ITEMS: 'Eléments',
    TOTAL_ITEMS: 'Total du panier',
    ADD_NEW_ADDRESS: 'Ajouter une nouvelle adresse',
    PLEASE_SELECT_AN_ADDRESS: 'Selectionner une adresse',
    TITLE: 'Titre',
    FIRST_NAME: 'Prénom',
    LAST_NAME: 'Nom',
    COMPANY: 'Nom de la Société',
    ADDRESS_LINE_1: 'Adresse ligne 1',
    ADDRESS_LINE_2: 'Adresse ligne 2',
    CITY_TOWN: 'Ville',
    POSTCODE: 'Code Postal',
    COUNTRY: 'Pays',
    COUNTY: 'Pays',
    TELEPHONE: 'Téléphone',
    MARK_AS_DEFAULT_BILLING_ADDRESS: 'Adresse de facturation par défaut',
    MARK_AS_DEFAULT_SHIPPING_ADDRESS: 'Adresse de livraison par défaut',
    USE_SAME_ADDRESS_FOR_SHIPPING_AND_BILLING:
      'Utiliser la même adresse pour la livraison et la facturation',
    DEFAULT_BILLING_ADDRESS: 'Adresse de facturation par défaut',
    DEFAULT_SHIPPING_ADDRESS: 'Adresse de livraison par défaut',
    DEFAULT_BILLING_SHIPPING_ADDRESS: 'Adresse de facturation/expédition par défaut',
    REQUIRED_FIELD: 'Champ requis',
    PLEASE_CHOOSE: 'Choisissez'
  },
  it_IT: {
    CANCEL: 'Cancella',
    DELETE: 'Elimina',
    DONE: 'Fatto',
    SAVE: 'Salva',
    APPLY: 'Applica',
    CHANGE: 'Cambia',
    ADDRESS: 'indirizzo',
    PRODUCT: 'Articolo',
    BILLING: 'Fatturazione',
    SHIPPING: 'Spedizione',
    DISSCOUNT_OR_VOUCHER_CODE: 'Codice sconto o voucher',
    BILLING_AND_SHIPPING: 'fatturazione and spedizione',
    PAY_BY_CREDIT_OR_DEBIT: 'Paga con carta di credito/debito',
    NAME_ON_CARD: 'Nome sulla carta',
    CARD_NUMBER: 'Numero di carta',
    EXPIRY_DATE: 'Data di scadenza',
    PRICE: 'Prezzo',
    TOTAL: 'Totale',
    SUBTOTIAL_EXCLUDING_DELIVERY_TAX: 'Subtotale esclusa consegna e tasse',
    DISCOUNT: 'Sconto',
    TAX: 'Tasse',
    QUANTITY: 'Quantità',
    CHECKOUT: 'Controlla',
    VIEW_CART: 'Visualizza il carrello',
    CONTINUE_SHOPPING: 'Continua a fare acquisti',
    ADDRESS_DELETE_MESSAGE: 'Sei sicuro di voler eliminare questo indirizzo?',
    ADD_TO_CART_STRING: 'Aggiungi la carta',
    ADD_TO_CART_PREORDER_STRING: 'Preordina ora',
    ADDED_TO_BASKET: 'aggiunto al carrello',
    EMPTY_CART_STRING: 'Il tuo carrello è vuoto.',
    ITEMS: 'Articoli',
    TOTAL_ITEMS: 'Totale articoli',
    ADD_NEW_ADDRESS: 'Inserisci un nuovo indirizzo',
    PLEASE_SELECT_AN_ADDRESS: 'Per favore seleziona un indirizzo',
    TITLE: 'Titolo',
    FIRST_NAME: 'Nome',
    LAST_NAME: 'Cognome',
    COMPANY: 'Nome azienda',
    ADDRESS_LINE_1: 'Indirizzo linea 1',
    ADDRESS_LINE_2: 'Indirizzo linea 2',
    CITY_TOWN: 'Città',
    POSTCODE: 'Cap',
    COUNTRY: 'Paese',
    COUNTY: 'Provincia',
    TELEPHONE: 'Telefono',
    MARK_AS_DEFAULT_BILLING_ADDRESS: 'Contrassegna come indirizzo di fatturazione predefinito',
    MARK_AS_DEFAULT_SHIPPING_ADDRESS: 'Contrassegna come indirizzo di spedizione predefinito',
    USE_SAME_ADDRESS_FOR_SHIPPING_AND_BILLING:
      'Usa lo stesso indirizzo per la spedizione e la fatturazione',
    DEFAULT_BILLING_ADDRESS: 'Indirizzo di fatturazione predefinito',
    DEFAULT_SHIPPING_ADDRESS: 'Indirizzo di spedizione predefinito',
    DEFAULT_BILLING_SHIPPING_ADDRESS: 'Indirizzo di fatturazione/spedizione predefinito',
    REQUIRED_FIELD: 'Campo obbligatorio',
    PLEASE_CHOOSE: 'Per favore scegli'
  },
  de_DE: {
    CANCEL: 'Abbrechen',
    DELETE: 'Löschen',
    DONE: 'Fertig',
    SAVE: 'Speichern',
    APPLY: 'Anwenden',
    CHANGE: 'ändern',
    ADDRESS: 'adresse',
    PRODUCT: 'Artikel',
    BILLING: 'Rechnung',
    SHIPPING: 'Versand',
    DISSCOUNT_OR_VOUCHER_CODE: 'Rabatt- oder Gutscheincode',
    BILLING_AND_SHIPPING: 'rechnung and versand',
    PAY_BY_CREDIT_OR_DEBIT: 'Bezahlen Sie mit Kredit-/Debitkarte',
    NAME_ON_CARD: 'Name auf der Karte',
    CARD_NUMBER: 'Kartennummer',
    EXPIRY_DATE: 'Ablaufdatum',
    PRICE: 'Preis',
    TOTAL: 'Betrag',
    SUBTOTIAL_EXCLUDING_DELIVERY_TAX: 'Zwischensumme exkl. Versand und Steuern',
    DISCOUNT: 'Rabatt',
    TAX: 'Steuer',
    QUANTITY: 'Menge',
    CHECKOUT: 'zur Kasse',
    VIEW_CART: 'zum Warenkorb',
    CONTINUE_SHOPPING: 'Weiter einkaufen',
    ADDRESS_DELETE_MESSAGE: 'Wollen Sie diese Adresse wirklich löschen?',
    ADD_TO_CART_STRING: 'In den Warenkorb legen',
    ADD_TO_CART_PREORDER_STRING: 'Vorbestellen',
    ADDED_TO_BASKET: 'dem Warenkorb hinzugefügt',
    EMPTY_CART_STRING: 'Ihr Warenkorb ist leer.',
    ITEMS: 'Artikel',
    TOTAL_ITEMS: 'Anzahl Artikel',
    ADD_NEW_ADDRESS: 'Neue Adresse hinzufügen',
    PLEASE_SELECT_AN_ADDRESS: 'Bitte Adresse ausählen',
    TITLE: 'Titel',
    FIRST_NAME: 'Vorname',
    LAST_NAME: 'Nachname',
    COMPANY: 'Firmenname',
    ADDRESS_LINE_1: 'Adresse 1',
    ADDRESS_LINE_2: 'Adresse 2',
    CITY_TOWN: 'Stadt',
    POSTCODE: 'PLZ',
    COUNTRY: 'Staat',
    COUNTY: 'Bundesland',
    TELEPHONE: 'Telefon',
    MARK_AS_DEFAULT_BILLING_ADDRESS: 'Als Standard-Rechnungsadresse auswählen',
    MARK_AS_DEFAULT_SHIPPING_ADDRESS: 'Als Standard-Lieferadresse auswählen',
    USE_SAME_ADDRESS_FOR_SHIPPING_AND_BILLING:
      'Gleiche Adresse für Lieferung und Rechnung verwenden',
    DEFAULT_BILLING_ADDRESS: 'Standard-Rechnungsadresse',
    DEFAULT_SHIPPING_ADDRESS: 'Standardversandadresse',
    DEFAULT_BILLING_SHIPPING_ADDRESS: 'Standard-Rechnungs-/Lieferadresse',
    REQUIRED_FIELD: 'Pflichtfeld',
    PLEASE_CHOOSE: 'Bitte wählen'
  }
};

export default translations;
